const state = {
  roles: null
}

const getters = {
  roles: state => state.roles
}

const actions = {
  setRoles ({ commit }, roles) {
    commit('SET_ROLES', roles)
  }
}

const mutations = {
  SET_ROLES (state, roles) {
    const { list } = roles
    state.roles = list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
